export default __webpack_public_path__ + "static/gallery-award-americanvoices-987476a28126aee04b8262d28fc226d5.jpg";